import { useState } from "react";
import { CommonDialog } from 'components';
import {
  Container,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  Paper,
  InputAdornment,
  ClickAwayListener,
} from "@material-ui/core";
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from 'react-i18next';
import { toast } from 'utils/helpers';
import api from 'utils/api';


const WorkReportNameModal = ({ objectId, nameList = [], forContractors = true, onClose, setUpdatedNames }) => {
  const [names, setNames] = useState(nameList);
  const [newName, setNewName] = useState("");
  const [search, setSearch] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  const { t } = useTranslation();

  const addName = async () => {
    const trimmed = newName.trim();
    try {
      if (!names.includes(trimmed)) {
        setUpdatedNames(true);
        setNames((prev) => [...prev, trimmed]);
        setNewName("");

        let params = { forContractors, names: [ ...names, trimmed ] };
        await api.post(`/estimates/${objectId}/set-managers-contractors`, params);
      } else toast(forContractors ? t("Rangovas jau pridėtas") : t("Darbų vadovas jau pridėtas"), "error");
    } catch (err) {
      console.error(err);
    }
  };

  const deleteName = async (index) => {
    setNames((prev) => prev.filter((_, i) => i !== index));

    try {
      setUpdatedNames(true);
      const filteredNames = _.filter(names, (name, i) => i !== index);
      await api.post(`/estimates/${objectId}/set-managers-contractors`, { forContractors, names: filteredNames });
    } catch (err) {
      console.error(err);
    }
  };

  const startEdit = (index) => {
    setEditingIndex(index);
    setEditValue(names[index]);
  };

  const confirmEdit = async () => {
    if (editingIndex !== null && editValue.trim()) {
      setNames((prev) => prev.map((n, i) => (i === editingIndex ? editValue.trim() : n)));
      try {
        setUpdatedNames(true);

        names[editingIndex] = editValue.trim();
        await api.post(`/estimates/${objectId}/set-managers-contractors`, { forContractors, names });
      } catch (err) {
        console.error(err);
      }
    }
    setEditingIndex(null);
  };

  const filtered = names.filter((n) => n.toLowerCase().includes(search.toLowerCase()));

  return (
    <CommonDialog visible>
      <ClickAwayListener onClickAway={() => onClose()}>
        <Container maxWidth="sm" onClickOutside={() => onClose()}>
          <Typography variant="h4" gutterBottom style={{ fontWeight: 600 }}>
            {forContractors ? t("Rangovų sąrašas") : t("Darbų vadovų sąrašas")}
          </Typography>

          <Paper style={{ padding: 24, marginBottom: 24 }} elevation={2}>
            <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
              <TextField
                label={forContractors ? t("Rangovas") : t("Darbų vadovas")}
                variant="outlined"
                size="small"
                fullWidth
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && addName()}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => addName()}
                style={{ whiteSpace: "nowrap" }}
                disabled={!newName}
              >
                {t("Pridėti")}
              </Button>
            </div>

            <TextField
              label={t("Paieška")}
              variant="outlined"
              size="small"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </Paper>

          <Paper elevation={2}>
            {filtered.length === 0 ? (
              <Typography
                variant="body1"
                color="textSecondary"
                style={{ padding: 24, textAlign: "center" }}
              >
                {forContractors ? t("Rangovų nerasta") : t("Darbų vadovų nerasta")}
              </Typography>
            ) : (
              <List style={{ maxHeight: "35vh", overflow: "auto" }}>
                {filtered.map((name, i) => {
                const originalIndex = names.indexOf(name);
                return (
                  <ListItem key={`${name}-${i}`} divider>
                    {editingIndex === originalIndex ? (
                      <>
                        <TextField
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && confirmEdit()}
                          size="small"
                          variant="outlined"
                          fullWidth
                          style={{ marginRight: 80 }}
                        />
                        <ListItemSecondaryAction>
                          <IconButton edge="end" onClick={confirmEdit}>
                            <CheckIcon style={{ color: "#4caf50" }} />
                          </IconButton>
                          <IconButton edge="end" onClick={() => setEditingIndex(null)}>
                            <CloseIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </>
                    ) : (
                      <>
                        <ListItemText primary={name} />
                        <ListItemSecondaryAction>
                          <IconButton edge="end" onClick={() => startEdit(originalIndex)}>
                            <EditIcon color="primary" />
                          </IconButton>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => deleteName(originalIndex)}
                          >
                            <RemoveCircleIcon color="secondary" />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </>
                    )}
                  </ListItem>
                );
              })}
              </List>
            )}
          </Paper>
          <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onClose()}
                  style={{ marginTop: 12 }}
              >
                  {t("Uždaryti")}
              </Button>
          </div>
        </Container>
      </ClickAwayListener>
    </CommonDialog>
  );
};

export default WorkReportNameModal;
